// src/components/Sidebar.js
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const Sidebar = () => {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  if (!user) return null;

  return (
    <div className="sidebar-dzwordnet">
      <div className="sidebar-header">
        <Link to="/">
          <img src="/logo.png" alt="DzWordnet Logo" className="sidebar-logo" />
        </Link>
      </div>
      <div className="sidebar-menu">
        <Link to="/profil" className={`sidebar-link${isActive('/profil') ? ' active' : ''}`}>
          <span className="sidebar-icon">👤</span>
          Mon Profil
        </Link>
        <Link to="/mes-contributions" className={`sidebar-link${isActive('/mes-contributions') ? ' active' : ''}`}>
          <span className="sidebar-icon">📖</span>
          Mes Contributions
        </Link>
        <Link to="/historique" className={`sidebar-link${isActive('/historique') ? ' active' : ''}`}>
          <span className="sidebar-icon">🕑</span>
          Historique d'Activité
        </Link>
        <div className="sidebar-link sidebar-dropdown">
          <span className="sidebar-icon">⚙️</span>
          Settings
          <div className="sidebar-dropdown-content">
            <Link to="/confidentialite" className="sidebar-dropdown-link">Confidentialité</Link>
            <Link to="/notifications" className="sidebar-dropdown-link">Notifications</Link>
            <Link to="/help" className="sidebar-dropdown-link">Help</Link>
          </div>
        </div>
      </div>
      <div className="sidebar-footer">
        <button className="sidebar-logout-btn" onClick={logout}>
          <span className="sidebar-icon">↩️</span>
          Log Out
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
